import { AxiosError } from 'axios';
import { GET_APPEAL_OUTCOME_URL } from '../../constants/apiUrls';
import { GET_APPEAL_OUTCOME_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Response Model
// =============================================================================
interface GetAppealOutcomeResponse {
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  fileKey: string;
  onSuccess?: (data: GetAppealOutcomeResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAppealOutcome = ({ fileKey, onSuccess, onError }: Input) => {
  const getAppealOutcome = async () => {
    const res = await axiosClient.get<void>(GET_APPEAL_OUTCOME_URL(fileKey));
    return res.data;
  };

  return useCustomQuery([GET_APPEAL_OUTCOME_KEY], getAppealOutcome, {
    onSuccess,
    onError,
    enabled: false,
  });
};
